import Constants from '../../constants';
import MiniGamesConfirmationModal from '../minigame_confirmation_modal';
import View from '../view';
import './index_web.css';
interface Props {
  mileStoneList: any;
  confirmationModal: Boolean;
  onPlayGameClick: any;
  onPressDismiss: any;
  entryFee: any;
  onConfirmationHandler: any;
  mileStonepercentageCalculator: any;
  gameInfoContainerStyle: any;
  mileStoneProgressStyle: any;
  gamePlayContainerStyle: any;
  mileStoneProgressedAreaStyle: any;
}
const MilesStonesWeb = ({
  mileStoneList = [],
  confirmationModal,
  onPlayGameClick,
  onPressDismiss,
  entryFee,
  onConfirmationHandler,
  mileStonepercentageCalculator,
  gameInfoContainerStyle,
  mileStoneProgressStyle,
  gamePlayContainerStyle,
  mileStoneProgressedAreaStyle
}: Props) => {
  return (
    <View className="mileStones__wrapper__web">
      {mileStoneList.map((item: any, idx: any) => (
        <div className="mileStones__container__web" key={idx}>
          <div className="mileStones__gameImg__container__web">
            <img src={item.gameImage} />
          </div>
          <View className="mileStones__gameInfo__container__web" style={gameInfoContainerStyle}>
            <p className="mileStones__gameName__web">{item.gameName}</p>
            <p className="mileStones__gameRepitition__web">{`Game Play repitition(${item.playedCount}/5)`}</p>
            <div style={{ display: 'flex', alignItems: 'center' }}>
              <div
                style={mileStoneProgressStyle}
                className={`mileStone__progress ${
                  mileStonepercentageCalculator(item.playedCount) === '0%' ? 'invisible' : ''
                }`}>
                <div
                  className="mileStone__progressBar"
                  role="progressbar"
                  style={{
                    ...mileStoneProgressedAreaStyle,
                    width: mileStonepercentageCalculator(item.playedCount)
                  }}></div>
              </div>
              <div className="mileStone__progress__text__wrapper">
                <div className="mileStone__progress__text">
                  {mileStonepercentageCalculator(item.playedCount)}
                </div>
              </div>
            </div>
          </View>
          <div className="mileStones__xp__playGame__container__web" style={gamePlayContainerStyle}>
            <div style={{ display: 'flex' }}>
              {' '}
              <Constants.Svgs.Xp />
              <p className="mileStones__xpValue__web">{`${item.xpAvailable} Exp`}</p>
            </div>
            <div>
              {' '}
              <button
                className="mileStones__xp__playGame__btn__web"
                onClick={() => onPlayGameClick(item)}>
                Play Game
              </button>
            </div>
          </div>
        </div>
      ))}
      <MiniGamesConfirmationModal
        visible={confirmationModal}
        onPressDismiss={onPressDismiss}
        onConfirmationHandler={onConfirmationHandler}
        EntryFee={entryFee}
      />
    </View>
  );
};

export default MilesStonesWeb;
